import React from "react"
import ReactDOM from "react-dom"
import { createStore, StoreProvider, action } from "easy-peasy"
import InventoryGlobal from "/components/InventoryGlobal"
import "./global.scss"
const store = createStore({
	domain: "",
	activeLot: false,
	mode: false,
	contactOpen: false, // desktop
	mobileContactOpen: false,
	scrollPos: 0, // for desktop
	listHover: null,
	activePanel: false,
	viewing: "homes",
	isMobile: false,
	largeDevice: false,
	allHomes: [],
	favorites: [],
	lastEvent: {},
	viewingFavorites: false,
	lastActionClick: "",
	pipsyClient: 0,
	propertyID: 0,
	flyBack: false,
	moveIn: true,
	underConst: true,
	premiumHomesites: true,
	builderOwnedHomesites: true,
	showMap: true,
	manualMapShow: true,
	lotOpenType: "", // This is whether they opened hte lot from the list or map
	selections: {
		builders: [],
		price: [],
		lot_types: [],
		sites: [],
		sqft: [],
		beds: [],
		baths: [],
		acreage: [],
	},
	selectedAreaFeatures: [],
	matchedList: [],
	unmatchedList: [],
	setMode: action((state, payload) => {
		state.mode = payload
	}),
	setListHover: action((state, payload) => {
		state.listHover = payload
	}),
	setLastEvent: action((state, payload) => {
		state.lastEvent = payload
	}),
	setFlyBack: action((state, payload) => {
		state.flyBack = payload
	}),
	setMoveIn: action((state, payload) => {
		state.moveIn = payload
	}),
	setUnderConst: action((state, payload) => {
		state.underConst = payload
	}),
	setPremiumHomesites: action((state, payload) => {
		state.premiumHomesites = payload
	}),
	setBuilderOwnedHomesites: action((state, payload) => {
		state.builderOwnedHomesites = payload
	}),
	setDomain: action((state, payload) => {
		state.domain = payload
	}),
	setMatchedList: action((state, payload) => {
		state.matchedList = payload
	}),
	setShowMap: action((state, payload) => {
		state.showMap = payload
	}),
	setManualMapShow: action((state, payload) => {
		state.manualMapShow = payload
	}),
	setViewingFavorites: action((state, payload) => {
		state.viewingFavorites = payload
	}),
	setUnmatchedList: action((state, payload) => {
		state.unmatchedList = payload
	}),
	setSelections: action((state, payload) => {
		state.selections = payload
	}),
	setActiveLot: action((state, payload) => {
		state.activeLot = payload
	}),
	setScrollPos: action((state, payload) => {
		state.scrollPos = payload
	}),
	setActivePanel: action((state, payload) => {
		state.activePanel = payload
	}),
	setContactOpen: action((state, payload) => {
		state.contactOpen = payload
	}),
	setMobileContactOpen: action((state, payload) => {
		state.mobileContactOpen = payload
	}),
	setViewing: action((state, payload) => {
		state.viewing = payload
	}),
	setSelectedAreaFeatures: action((state, payload) => {
		state.selectedAreaFeatures = payload
	}),
	setIsMobile: action((state, payload) => {
		state.isMobile = payload
	}),
	setLargeDevice: action((state, payload) => {
		state.largeDevice = payload
	}),
	setFavorites: action((state, payload) => {
		state.favorites = payload
	}),
	setAllHomes: action((state, payload) => {
		state.allHomes = payload
	}),
	setPipsyClient: action((state, payload) => {
		state.pipsyClient = payload
	}),
	setProperty: action((state, payload) => {
		state.propertyID = payload
	}),
	setLotOpenType: action((state, payload) => {
		state.lotOpenType = payload
	}),
})
ReactDOM.render(
	<div className="pipsy__global">
		<StoreProvider store={store}>
			<InventoryGlobal />
		</StoreProvider>
	</div>,
	document.getElementById("pipsyRoot")
)